const navigation = {
  id: 'group-dashboard-loading-unique',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      icon: 'ph ph-house-line',
      url: '/dashboard'
    },
	{		
	  id: 'movies',
	  title: 'Movies',
	  type: 'collapse',
	  icon: 'ph ph-film-strip',
	  children: [
		{
		  id: 'movies-add',
		  title: 'Add Movies',
		  type: 'item',
		  url: '/movies/add'
		},
		{
		  id: 'view-movies',
		  title: 'View Movies',
		  type: 'item',
		  url: '/movies'
		},
		{
		  id: 'view-next-change-movies',
		  title: 'View Next Change Movies',
		  type: 'item',
		  url: '/movies/next-change'
		},
		{
		  id: 'view-coming-soon-movies',
		  title: 'View Coming Soon Movies',
		  type: 'item',
		  url: '/movies/coming-soon'
		}
	  ]
	},
	{
	  id: 'offers',
	  title: 'Offers',
	  type: 'collapse',
	  icon: 'ph ph-tag',
	  children: [
		{
		  id: 'offers-list',
		  title: 'View Offers',
		  type: 'item',
		  url: '/offers'
		},
		{
		  id: 'offers-add',
		  title: 'Add Offer',
		  type: 'item',
		  url: '/offers/add'
		}
	  ]
	},
	{
      id: 'sync',
      title: 'Sync',
      type: 'item',
      icon: 'ph ph-arrows-clockwise',
      action: 'SYNC_DATA'
    },	{
	  id: 'reports',
	  title: 'Reports',
	  type: 'collapse',
	  icon: 'ph ph-chart-bar',
	  children: [
	  	{
		  id: 'search-booking-report',
		  title: 'Search Booking Report',
		  type: 'item',
		  url: '/reports/search-booking-report'
		},
	    {
		  id: 'daily-report',
		  title: 'Daily Report',
		  type: 'item',
		  url: '/reports/daily-report'
		},
		{
		  id: 'booking-report',
		  title: 'Booking Report',
		  type: 'item',
		  url: '/reports/booking-report'
		},
	  	{
		  id: 'revenue',
		  title: 'Revenue Report',
		  type: 'item',
		  url: '/reports/revenue'
		},
		{
		  id: 'failed-bookings',
		  title: 'Failed Bookings',
		  type: 'item',
		  url: '/reports/failed-bookings'
		},
		{
		  id: 'transaction',
		  title: 'Transaction Report',
		  type: 'item',
		  url: '/reports/transaction'
		}
	  ]
	},
	{
	  id: 'update-license',
	  title: 'Update License',
	  type: 'item',
	  icon: 'ph ph-key',
	  url: '/update-license/'
	},
	{
	  id: 'manage-setting',
	  title: 'Manage Setting',
	  type: 'item',
	  icon: 'ph ph-gear-six',
	  url: '/manage-setting'
	},
	{
	  id: 'manage-outlets',
	  title: 'Manage Outlets',
	  type: 'item',
	  icon: 'ph ph-storefront',
	  url: '/manage-outlets'
	},
	{
	  id: 'manage-outlets-labs',
	  title: 'Manage Outlets Labs',
	  type: 'item',
	  icon: 'ph ph-sliders-horizontal',
	  url: '/manage-outlets-labs'
	}
  ]
};

export default navigation;